import { render, staticRenderFns } from "./CouponStatusCard.vue?vue&type=template&id=4c9912f6&scoped=true&"
import script from "./CouponStatusCard.vue?vue&type=script&lang=js&"
export * from "./CouponStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponStatusCard.vue?vue&type=style&index=0&id=4c9912f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9912f6",
  null
  
)

export default component.exports